import { watchEffect } from 'vue'
import {
  DeepMsgBoxPlugin,
  locales,
  setI18nLocale as setI18nLocaleDeepUiLib,
} from '@deepcloud/deep-ui-lib'
import { setI18nLocale as setI18nLocaleFieldValidators } from '@deepcloud/field-validators'
import i18n from '@/plugins/i18n'
import type { App } from 'vue'

// Add DeepUiLib locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', locales.de)
i18n.global.mergeLocaleMessage('fr', locales.fr)
i18n.global.mergeLocaleMessage('it', locales.it)
i18n.global.mergeLocaleMessage('en', locales.en)

// update plugins i18n locale
watchEffect(() => {
  setI18nLocaleDeepUiLib(i18n.global.locale.value)
  setI18nLocaleFieldValidators(i18n.global.locale.value)
})

export default {
  install: (app: App) => {
    app.use(DeepMsgBoxPlugin, {
      msgBox: {
        i18n: i18n.global,
        closable: true,
        btnActions: {
          cancel: {
            name: 'cancel',
            titleI18nKey: 'actions.cancel',
            color: 'primary',
            variant: 'outlined',
            slim: false,
          },
          confirm: {
            name: 'confirm',
            titleI18nKey: 'actions.confirm',
            color: 'secondary',
            variant: 'flat',
            slim: false,
          },
        },
        dialogProps: {
          persistent: true,
          class: 'text-body-medium',
          width: 450,
        },
      },
    })
  },
}
